import script from "./IntegraDulceDeLechePromoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegraDulceDeLechePromoModal.vue?vue&type=script&setup=true&lang=js"

import "./IntegraDulceDeLechePromoModal.vue?vue&type=style&index=0&id=4b530b4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b530b4c"]])

export default __exports__